module.exports = __webpack_public_path__ + "static/media/delivery.1426f887.svg";